const parseAsFloat = (str) => {
    const [sign, numberStr] = str.startsWith('-') ? [-1, str.slice(1)] : [1, str];
    const [integerPart, decimalPart] = numberStr.replace(/^0+/, '0').split('-');
    return sign * (decimalPart === undefined
        ? parseInt(integerPart, 10)
        : parseFloat(`${integerPart}.${decimalPart}`));
};
export const mapSelection = (selection) => {
    const [id, handicap] = selection.id.split('_');
    return {
        selectionId: id,
        handicap: handicap ? parseAsFloat(handicap) : null,
    };
};
